import React, { useState } from 'react';
import { ChevronDown, Bot, Sparkles, Zap, Brain } from 'lucide-react';

const AI_MODELS = [
  { 
    id: 'chatgpt', 
    name: 'ChatGPT', 
    description: 'OpenAI GPT-3.5 Turbo',
    icon: Bot,
    color: 'text-green-600',
    bgColor: 'bg-green-50'
  },
  { 
    id: 'gemini', 
    name: 'Gemini', 
    description: 'Google Gemini Pro',
    icon: Sparkles,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50'
  },
  { 
    id: 'claude', 
    name: 'Claude', 
    description: 'Anthropic Claude 3 Haiku',
    icon: Brain,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50'
  },
  { 
    id: 'deepseek', 
    name: 'DeepSeek', 
    description: 'DeepSeek Chat',
    icon: Zap,
    color: 'text-orange-600',
    bgColor: 'bg-orange-50'
  }
];

const ModelSelector = ({ selectedModel, onModelChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentModel = AI_MODELS.find(model => model.id === selectedModel);
  const CurrentIcon = currentModel?.icon || Bot;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 sm:space-x-3 bg-white border border-gray-300 rounded-lg px-3 sm:px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent cursor-pointer min-w-[180px] sm:min-w-[240px] hover:bg-gray-50 transition-colors"
      >
        <div className={`w-6 h-6 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center ${currentModel?.bgColor || 'bg-gray-50'}`}>
          <CurrentIcon className={`w-3 h-3 sm:w-4 sm:h-4 ${currentModel?.color || 'text-gray-600'}`} />
        </div>
        <div className="flex-1 text-left min-w-0">
          <div className="font-medium text-gray-900 text-sm sm:text-base truncate">{currentModel?.name}</div>
          <div className="text-xs text-gray-500 hidden sm:block truncate">{currentModel?.description}</div>
        </div>
        <ChevronDown className={`w-3 h-3 sm:w-4 sm:h-4 text-gray-400 transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-hidden">
          {AI_MODELS.map((model) => {
            const ModelIcon = model.icon;
            const isSelected = model.id === selectedModel;
            
            return (
              <button
                key={model.id}
                onClick={() => {
                  onModelChange(model.id);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center space-x-2 sm:space-x-3 px-3 sm:px-4 py-2.5 sm:py-3 hover:bg-gray-50 transition-colors ${
                  isSelected ? 'bg-primary-50 border-l-4 border-primary-500' : ''
                }`}
              >
                <div className={`w-6 h-6 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center ${model.bgColor}`}>
                  <ModelIcon className={`w-3 h-3 sm:w-4 sm:h-4 ${model.color}`} />
                </div>
                <div className="flex-1 text-left min-w-0">
                  <div className={`font-medium text-sm sm:text-base truncate ${isSelected ? 'text-primary-900' : 'text-gray-900'}`}>
                    {model.name}
                  </div>
                  <div className={`text-xs truncate ${isSelected ? 'text-primary-700' : 'text-gray-500'}`}>
                    {model.description}
                  </div>
                </div>
                {isSelected && (
                  <div className="w-2 h-2 bg-primary-500 rounded-full"></div>
                )}
              </button>
            );
          })}
        </div>
      )}

      {isOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default ModelSelector;
